// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chartkit-error {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 16px;
  overflow: auto;
}
.chartkit-error__title {
  display: flex;
  align-items: center;
  color: var(--g-color-text-primary);
  font-size: 13px;
  line-height: 16px;
  margin-bottom: 12px;
}
.chartkit-error .chartkit-error__icon {
  color: var(--g-color-text-danger);
  margin-right: 8px;
}`, "",{"version":3,"sources":["webpack://./src/ui/libs/DatalensChartkit/ChartKit/components/Error/Error.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;AACJ;AACI;EACI,aAAA;EACA,mBAAA;EACA,kCAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AACR;AAEI;EACI,iCAAA;EACA,iBAAA;AAAR","sourcesContent":[".chartkit-error {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  padding: 16px;\n  overflow: auto;\n}\n.chartkit-error__title {\n  display: flex;\n  align-items: center;\n  color: var(--g-color-text-primary);\n  font-size: 13px;\n  line-height: 16px;\n  margin-bottom: 12px;\n}\n.chartkit-error .chartkit-error__icon {\n  color: var(--g-color-text-danger);\n  margin-right: 8px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
